import { FC } from "react";
import Table from "components/atoms/Table";
import Drawer from "components/atoms/Drawer";
import Sidebar from "components/molecules/Sidebar";
import "styles/results-list.scss";
import { useSelector } from "react-redux";
import * as SearchSlice from "store/slice/search.slice";
import { useDispatch } from "react-redux";
import type { RootState } from "store";
import cx from "classnames";
import SimpleBar from "simplebar-react";
import { ResultsListProps } from "types/molecules.types";

const columns = [
  { title: "Partner", dataProperty: "partner_name" },
  { title: "Miles", dataProperty: "miles" },
  { title: "Time (Hours)", dataProperty: "time_minutes" },
  { title: "NPS", dataProperty: "nps" },
  { title: "Mileage Charge", dataProperty: "milage_rate" },
  { title: "Labor Charge", dataProperty: "labor_rate" },
  { title: "Travel Charge", dataProperty: "travel_rate" },
  { title: "Estimate", dataProperty: "estimate" },
];

const ResultsList: FC<ResultsListProps> = ({ isDesktop }) => {
  const { data, showDrawer, isSearchBtnClicked } = useSelector((state: RootState) => state.search);
  
  const surfaceClass = cx({
    "has-back-btn": isSearchBtnClicked && !isDesktop,
    "is-asr-dekstop": isDesktop,
  });
  const dispatch = useDispatch();
  const hanldeOnSelectedRow = () => {
    dispatch(SearchSlice.setIsModalShow(true));
  };

  const handleOnClickBackBtn = () => {
    dispatch(SearchSlice.onClearData());
    dispatch(SearchSlice.setIsSearchBtnClicked(false))
    dispatch(SearchSlice.setIsEdit(false));
  };

  const title =
    isDesktop || isSearchBtnClicked
      ? `There are ${
          data?.asrList && data?.asrList.length
        } KOHLER ASR in your area`
      : "Find KOHLER Authorized Service Representative";

  const maxHeight = isDesktop ? { maxHeight: "270px" } : { maxHeight: "383px" };

  return (
    <div className={isSearchBtnClicked && !isDesktop ? "surface-screen" : ""}>
      {showDrawer && (
        <Drawer
          title={title}
          onClick={handleOnClickBackBtn}
          isBackLink={!isDesktop}
          isSearchClicked={isSearchBtnClicked}
        >
          {!isDesktop && !isSearchBtnClicked && <Sidebar isDesktop={isDesktop} />}
          {isSearchBtnClicked && isSearchBtnClicked && (
            <div className={surfaceClass}>
              <SimpleBar
                scrollbarMinSize={100}
                scrollbarMaxSize={205}
                autoHide={false}
                style={maxHeight}
              >
                <Table
                  columns={columns}
                  data={data.asrList}
                  uidProperty="partner"
                  onSelect={hanldeOnSelectedRow}
                />
              </SimpleBar>
            </div>
          )}
        </Drawer>
      )}
    </div>
  );
};

export default ResultsList;
